import { T, TYPE_ICONS } from "../constants";
import TypeBadge from "../shared/TypeBadge";
import PropPill from "../shared/PropPill";
import IngredientRow from "./IngredientRow";

export default function Modal({ item, onClose }) {
  if (!item) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0,
        background: "rgba(42,61,34,0.65)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "1rem", zIndex: 1000,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: T.linen,
          borderRadius: "4px",
          maxWidth: "540px", width: "100%",
          maxHeight: "88vh", overflowY: "auto",
          display: "flex", flexDirection: "column",
        }}
      >
        {/* Header */}
        <div style={{ background: T.moss, padding: "1.5rem 1.5rem 1.25rem" }}>
          <div style={{
            display: "flex", justifyContent: "space-between",
            alignItems: "flex-start", marginBottom: "0.75rem",
          }}>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <TypeBadge type={item.type} />
              <span style={{ fontSize: "1.4rem" }}>{TYPE_ICONS[item.type] || "🌿"}</span>
            </div>
            <button
              onClick={onClose}
              style={{
                background: "rgba(255,255,255,0.15)", border: "none",
                width: "28px", height: "28px", borderRadius: "2px",
                cursor: "pointer", fontSize: "0.85rem", color: T.headerText,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}
            >✕</button>
          </div>
          <h2 style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: "1.9rem", fontWeight: 500, fontStyle: "italic",
            color: T.headerText, margin: "0 0 0.4rem", lineHeight: 1.1,
          }}>
            {item.name}
          </h2>
          <p style={{ fontSize: "0.875rem", color: "rgba(240,247,235,0.6)", lineHeight: 1.65, margin: 0 }}>
            {item.description}
          </p>
        </div>

        {/* Properties */}
        <div style={{ padding: "1rem 1.5rem 0", background: T.linen2 }}>
          <div style={{
            fontSize: "0.62rem", letterSpacing: "0.14em",
            textTransform: "uppercase", color: T.muted, marginBottom: "0.5rem",
          }}>
            Properties
          </div>
          <div style={{
            display: "flex", flexWrap: "wrap", gap: "5px",
            paddingBottom: "1rem", borderBottom: `0.5px solid ${T.linen3}`,
          }}>
            {item.properties.map(p => <PropPill key={p} label={p} />)}
          </div>
        </div>

        {/* Ingredients */}
        <div style={{ padding: "1rem 1.5rem 0", background: T.linen2 }}>
          <div style={{
            fontSize: "0.62rem", letterSpacing: "0.14em",
            textTransform: "uppercase", color: T.muted, marginBottom: "0.25rem",
          }}>
            Ingredients
          </div>
          {item.ingredients.map((ing, i) => (
            <IngredientRow key={i} ing={ing} isLast={i === item.ingredients.length - 1} />
          ))}
        </div>

        {/* Preparation */}
        <div style={{ padding: "1rem 1.5rem", background: T.linen }}>
          <div style={{
            fontSize: "0.62rem", letterSpacing: "0.14em",
            textTransform: "uppercase", color: T.muted, marginBottom: "0.5rem",
          }}>
            How to prepare
          </div>
          <p style={{ fontSize: "0.875rem", color: T.bark, lineHeight: 1.75, margin: 0 }}>
            {item.preparation}
          </p>
        </div>

        {/* Notes */}
        {item.notes && (
          <div style={{
            margin: "0 1.5rem 1.25rem",
            borderLeft: `2.5px solid ${T.lime}`,
            paddingLeft: "12px",
          }}>
            <div style={{
              fontSize: "0.62rem", letterSpacing: "0.14em",
              textTransform: "uppercase", color: T.muted, marginBottom: "0.35rem",
            }}>
              Notes
            </div>
            <p style={{ fontSize: "0.85rem", color: T.bark, lineHeight: 1.65, margin: 0, fontStyle: "italic" }}>
              {item.notes}
            </p>
          </div>
        )}

        <p style={{ fontSize: "0.68rem", color: T.muted, textAlign: "center", padding: "0 1.5rem 1.25rem" }}>
          From <em>Nature's Cookbook</em> by Cynthia Rico Cook et al. — not medical advice.
        </p>
      </div>
    </div>
  );
}
